import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { defineMessages, injectIntl } from 'react-intl';

import BasicDataPod from '../../../components/BasicDataPod';
import Value from '../../../components/BasicDataPod/Value';
import Description from '../../../components/BasicDataPod/Description';
import Link from '../../../components/BasicDataPod/Link';
import { getDollarFormattedText } from '../../../utils/strings';
import findBestMatch, {
  AWARD_FULL_TUITION,
  AWARD_RANGE,
} from '../../../utils/scholarships';
import getStudentProfileScores from '../../../utils/studentProfiles';

import './styles.css';

const messages = defineMessages({
  meritBasedScholarship: {
    id: 'hubs.overview.pod.average-net-price',
    defaultMessage: 'Potential Merit-Based Scholarships',
  },
  mbsLinkText: {
    id: 'hubs.overview.pod.average-net-price.more-about-cost',
    defaultMessage: 'More about Scholarships',
  },
});

const getAmount = (scholarship) => {
  if (scholarship.awardType === AWARD_FULL_TUITION) return 'Full Tuition';
  return getDollarFormattedText(scholarship.awAmountMin);
};

const MeritBasedScholarship = ({
  scholarships,
  applicationStatistics,
  highSchool,
  userData,
  testScores,
  lastUpdated,
  intl,
}) => {
  const allScholarships = get(scholarships, 'scholarships', []);
  if (!allScholarships || allScholarships.length === 0) {
    return null;
  }

  const studentProfile = getStudentProfileScores(
    applicationStatistics,
    highSchool,
    userData,
    testScores,
  );
  const bestMatchedScholarship = findBestMatch(allScholarships, studentProfile);

  return bestMatchedScholarship ? (
    <BasicDataPod
      header={intl.formatMessage(messages.meritBasedScholarship)}
      footer={lastUpdated}
    >
      <div className="scholarship-pod-value-container">
        <Value
          value={getAmount(bestMatchedScholarship)}
          className={
            bestMatchedScholarship.awardType !== AWARD_FULL_TUITION ? '' : 'simple-text'
          }
          type={
            bestMatchedScholarship.awardType !== AWARD_FULL_TUITION
              ? 'currency'
              : undefined
          }
          addPlusSign={bestMatchedScholarship.awardType === AWARD_RANGE}
        />
        <Description
          text={bestMatchedScholarship.renewable ? 'per year' : 'one-time'}
          className="scholarship-pod-description-text"
        />
      </div>
      <Link
        linkText={intl.formatMessage(messages.mbsLinkText)}
        linkUrl="Costs#financialaid"
      />
    </BasicDataPod>
  ) : null;
};

MeritBasedScholarship.propTypes = {
  scholarships: PropTypes.object,
  lastUpdated: PropTypes.string,
  applicationStatistics: PropTypes.object,
  userData: PropTypes.object,
  testScores: PropTypes.arrayOf(PropTypes.object),
  highSchool: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(MeritBasedScholarship);
